'use strict';

// Stub for React Native modules that get walked by @turnkey/core's mobile
// stampers (react-native-keychain, passkey-stamper). Real modules are never
// executed on web — Turnkey gates them behind platform checks — but bundlers
// walk the import path statically. CJS Proxy so any named import resolves to
// undefined instead of failing static analysis.
//
// Why here and not at the pnpm level: pnpm has no per-workspace scoping for
// optional peer dependencies. @turnkey/core declares react-native-keychain /
// @react-native-async-storage/async-storage / @turnkey/react-native-passkey-
// stamper as optional peers. Once mobile installs @turnkey/sdk-react-native
// (which transitively pulls them), pnpm hoists them into the workspace store
// and links them into @turnkey/core's resolution for ALL consumers — frontend
// included. Tried `dedupe-peer-dependents=false` (created variants but
// frontend's wallet-kit still landed on the RN-peer variant) and
// packageExtensions with null (pnpm 9 only merges, doesn't remove peers).
// Bundler-side alias is the correct localized fix.

const stub = new Proxy(
  {},
  {
    get(_target, key) {
      if (key === '__esModule') return true;
      if (key === 'default') return stub;
      return undefined;
    },
  },
);

module.exports = stub;
